import 'Content/messages.scss';
import { TextHelpers } from 'helpers/text';
import {parse} from 'marked';

export default function () {
    this.getView = () => require('views/discussionMessage.html');

    this.title = TextHelpers.decodeText(WCC.getSetting("Title", ''));
    this.messageKey = WCC.getSetting("MessageKey", '');

    this.message = '';
    
    if (system.isNotNullOrEmpty(this.messageKey)) {
        this.message = messages[this.messageKey];
    }
    else {
        this.message = parse(WCC.getSetting("Message", ''));
    }
    
    this.showMessageTitle = WCC.getSetting("ShowMessageTitle", false);
    this.hideMessageIcon = WCC.getSetting("HideMessageIcon", false);

    this.hasContent = _(this.title).any() && _(this.message).any();

    this.canActivate = function () {
        if (!this.hasContent)
            return { redirect: "#" }

        return true;
    }
};